// START Open Requre.JS wrapper
define(["jquery"],
		function($){

	var DEBUG = false;

	var priceContainerUtil = function(priceContainer){

		if (!(this instanceof priceContainerUtil)) {
			return new priceContainerUtil(priceContainer);
		}

		this.priceContainer = priceContainer;
		this.$price  		= priceContainer.find(".product-price-amount-js");
		this.$priceOri 		= priceContainer.find(".original-price-js");
		this.$priceCur 		= priceContainer.find(".current-price-js");
		if(WCS_CONFIG.get('grid::productShowDiscountPercentage') === true) {
			this.$priceDis		= priceContainer.find(".discount-price-js");
		}
		this.wasText 		= this.$priceOri.data("text");
		this.nowText 		= this.$priceCur.data("text");

	};

	priceContainerUtil.prototype = {

		init : function(){
			var self = this;


			return self;
		},

		setDataAmount : function(dataAmountPrice){

			if ( DEBUG ) console.log('setDataAmount');

			this.$price.data("amount", dataAmountPrice);
		},

		setPriceContainer : function(priceContainer){

			if ( DEBUG ) console.log('setPriceContainer');

			this.priceContainer = priceContainer;
		},

		getPriceContainer : function(){

			if ( DEBUG ) console.log('getPriceContainer');

			return this.priceContainer;
		},

		hideAllPrices : function(){

			if ( DEBUG ) console.log('hideAllPrices');

			this.$price.hide();
			this.$priceOri.hide();
			this.$priceCur.hide();
			if(WCS_CONFIG.get('grid::productShowDiscountPercentage') === true) {
				this.$priceDis.hide();
			}
		},

	    showSalePrice : function(listPrice, price, priceNumeric, listPriceNumeric, noSaleOnHighListPrice){

	    	if ( DEBUG ) console.log('showSalePrice');

	    	if(WCS_CONFIG.get('grid::productShowDiscountPercentage') === true) {
	    		var discountPrice;
	    		var discountText = this.$priceDis.data('text');

	    		discountPrice = this.getDiscountPercentage(priceNumeric, listPriceNumeric);

		    	if(this.priceContainer.hasClass('positive-discount-price')) {
		    		this.$priceCur.css("visibility", "visible");

		    		if(discountText) {
	    				discountPrice = discountPrice + discountText;
	    			}
	    		}

	    		this.$priceDis.html(discountPrice);
				this.$priceDis.show();
	    	} else {
	    		this.priceContainer.removeClass('positive-discount-price');
	    	}

          var hasPriceCur = this.$priceCur.length;

          // check if current price element exists in the DOM.
          // if not then perform simple price update.
          if (hasPriceCur) {
            this.$priceOri.html(this.wasText + " " + listPrice);
            this.$priceCur.html(this.nowText + " " + price);
            this.$price.html("");
            this.$price.hide();

            if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled')  && noSaleOnHighListPrice ){
              this.$priceOri.hide();
            } else {
              this.$priceOri.show();
            }

            this.$priceCur.show();
          } else {
            this.$priceOri.html(listPrice);
            this.$price.html(price);
          }

          if(WCS_CONFIG.get('grid::productShowDiscountPercentage') === true) {
            this.$priceDis.show();
          }

          $.pubsub('publish', 'product.price.updated', price);
	    },

	    getDiscountPercentage : function(priceNumeric, listPriceNumeric) {

    		var discountPrice,
    			priceNumericLen = priceNumeric.length,
				listPriceNumericLen = typeof listPriceNumeric === "number" ? 1 : listPriceNumeric.length; // check type to resolve undefined length when listPriceNumeric is number instead of array

    		if(priceNumericLen <= 1 && listPriceNumericLen <= 1) {
    			discountPrice = this.calculateDiscount(priceNumeric[0], listPriceNumeric);

				if(this.priceContainer.hasClass('positive-discount-price')) {
	    			discountPrice *= -1;
	    		}

	    		discountPrice += "%";

    		} else {
				if( WCS_CONFIG.get('PDP::pdpListPriceRangeEnabled') ){
					var discountPercentage1, discountPercentage2;

					// handle 2 listPrices
					if ( $.isArray(listPriceNumeric) ){
						discountPercentage1 = this.calculateDiscount(priceNumeric[0], listPriceNumeric[0]) + "%";

						if(listPriceNumericLen > 1) {
							discountPercentage2 = this.calculateDiscount(priceNumeric[priceNumericLen - 1], listPriceNumeric[1]) + "%";
							discountPrice = discountPercentage1+' '+'-'+' '+discountPercentage2;
						}
						else {
							discountPrice = discountPercentage1;
						}
					}
					else {
						//handle one list price with two lowPrices
						discountPercentage1 = this.calculateDiscount(priceNumeric[0], listPriceNumeric) + "%";
						discountPercentage2 = this.calculateDiscount(priceNumeric[1], listPriceNumeric) + "%";

						//list the smaller discount first in the range
						discountPrice = ( priceNumeric[0] < priceNumeric[1] ? discountPrice = discountPercentage2+' '+'-'+' '+discountPercentage1 : discountPrice = discountPercentage1+' '+'-'+' '+discountPercentage2 );
					}
				}
				else {
	    			for(i=0 ; i<priceNumericLen;i++){
						priceNumeric[i] = Math.round((((priceNumeric[i]-listPriceNumeric)*100)/listPriceNumeric)) + "%";
					}
					discountPrice = priceNumeric[1]+' '+'-'+' '+priceNumeric[0];
				}
    		}

    		if(WCS_CONFIG.get('PDP::pdpDisplayBracketInDiscountPercent') === true) {
    			discountPrice = '['+discountPrice+']';
    		}

    		return discountPrice;
	    },
		calculateDiscount : function(priceNumeric, listPriceNumeric) {
			// returns percentages as a negative integer to reflect mark-down
			var discountPercentage = Math.round((( priceNumeric - listPriceNumeric )*100/listPriceNumeric )) || 0;

			return discountPercentage;
	    },
	    updatePriceHTML : function(setToZero, price) {

			if ( DEBUG ) console.log('updatePriceHTML');

			if(setToZero) {
				this.$price.data("amount", 0.00);
			}
			if(price) {
				this.$price.html(price);
				this.$price.show();
			} else {
				this.$price.html("");
				this.$price.show();
			}
			this.$priceOri.html("");
			this.$priceCur.html("");
			if(this.$priceDis)
				this.$priceDis.hide();

			if(WCS_CONFIG && typeof(WCS_CONFIG.get) === 'function' && WCS_CONFIG.get('PDP::pdpShowPromoPriceOnly') === true) {
				// Adds class to default to original price color
				this.$priceCur.addClass('no-discount');
				this.$price.addClass('no-discount');
			}

			$.pubsub('publish', 'product.price.updated', price);
		}

	}; // end priceContainerUtil.prototype
// START close Require.JS wrapper

	return priceContainerUtil;
	}
);
// END close Require.JS wrapper
